import axios from './axiosClient'
 
const customerAPI = {
    getCustomerList: (searchTerm,params) =>{
        const url = `/Customer/search/${searchTerm}`
       return axios.get(url,{params})
    },
}

export default customerAPI;